import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import { useMemo } from "react";
import { MediaCardProps } from "../../../components/MediaCard/MediaCard";
import { ProductCard } from "../../../components/ProductCard/ProductCard";
import mediaDetailPageStyles from "../../media-detail-page.module.css";
import { mediaDetailProducts } from "../../mock-media";

type DirectTakeawayStepProps = {
  media: MediaCardProps;
};
export const DirectTakeawayStep = ({ media }: DirectTakeawayStepProps) => {
  const { t } = useTranslation();
  const products = useMemo(
    () => (media ? mediaDetailProducts(media.id) : []),
    [media]
  );

  return (
    <section className={mediaDetailPageStyles["field"]}>
      <FixaText tagName="h2" className={mediaDetailPageStyles["title"]}>
        {t("directTakeawayString")}
      </FixaText>

      <FixaText tagName="p">{t("directTakeawayDescriptionString")}</FixaText>

      <div className={mediaDetailPageStyles["productsGrid"]}>
        {products.map(({ item, article, badges, saleStartDate }) => (
          <ProductCard
            key={article.id}
            item={item}
            article={article}
            badges={badges}
            saleStartDate={saleStartDate}
          />
        ))}
      </div>
    </section>
  );
};
